"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const AccessProvider_1 = require("./AccessProvider");
const DefaultInsufficientPermissionsIndicator_1 = __importDefault(require("./DefaultInsufficientPermissionsIndicator"));
const DefaultPermissionsLoadingIndicator_1 = __importDefault(require("./DefaultPermissionsLoadingIndicator"));
const GuardedRoute = ({ exact, permissionType, children, path, redirectToPage, redirectToPageUrl = '/', insufficientPermissionsIndicatorComponent = DefaultInsufficientPermissionsIndicator_1.default, permissionsLoadingIndicator = DefaultPermissionsLoadingIndicator_1.default, isAuthenticated, notAuthenticatedComponent, showLoadingIndicator = true }) => {
    const access = react_1.default.useContext(AccessProvider_1.AccessContext);
    if (isAuthenticated === false && notAuthenticatedComponent) {
        return react_1.createElement(notAuthenticatedComponent);
    }
    if (!access.loaded && showLoadingIndicator) {
        return react_1.createElement(permissionsLoadingIndicator);
    }
    if (!access.loaded && !showLoadingIndicator) {
        return null;
    }
    if (access.has(permissionType)) {
        return (react_1.default.createElement(react_router_dom_1.Route, { exact: exact, path: path }, children));
    }
    if (redirectToPage) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: redirectToPageUrl });
    }
    return react_1.createElement(insufficientPermissionsIndicatorComponent);
};
exports.default = GuardedRoute;
